import { render, staticRenderFns } from "./SearchRecords.vue?vue&type=template&id=40013add&scoped=true&"
import script from "./SearchRecords.vue?vue&type=script&lang=js&"
export * from "./SearchRecords.vue?vue&type=script&lang=js&"
import style0 from "./SearchRecords.vue?vue&type=style&index=0&id=40013add&lang=scss&scoped=true&"
import style1 from "./SearchRecords.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40013add",
  null
  
)

export default component.exports